import {useEffect} from 'react'
import {init} from '@amplitude/analytics-browser'
import {amplitudeDev, amplitudeProd} from '@helpers/events/config'
import getEnv from '@providers/getEnv'

export default function useEvents() {
  useEffect(() => {
    const amplitudeApiKey = getEnv() === 'prod' ? amplitudeProd : amplitudeDev
    // Init amplitude
    init(amplitudeApiKey)
  }, [])
  return null
}

export const WithEvents = ({children}) => {
  useEvents()
  return children
}
